// extracted by css-extract-rspack-plugin
export default {"cls1":"PaywallPage-cls1_KyM","cls2":"PaywallPage-cls2_FgZ PaywallPage-cls1_KyM"};